import { render, staticRenderFns } from "./ended-vote.vue?vue&type=template&id=1b9e94c0&scoped=true&"
import script from "./ended-vote.vue?vue&type=script&lang=js&"
export * from "./ended-vote.vue?vue&type=script&lang=js&"
import style0 from "./ended-vote.vue?vue&type=style&index=0&id=1b9e94c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e94c0",
  null
  
)

export default component.exports